import styled from "styled-components";

export const InfoBlockContainer = styled.div`
    width: 100%;
    background: white;
    border-radius: var(--radius-lg);
    overflow: hidden;
    border: 1px solid var(--color-border);
    transition: var(--transition);
    box-shadow: var(--shadow-sm);

    &:hover {
        transform: translateY(-4px);
        box-shadow: var(--shadow-md);
        border-color: var(--color-primary-light);
    }
`;

export const ImageBlock = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 7 / 5;
    overflow: hidden;
`;

export const InfoText = styled.p`
    color: var(--color-text);
    line-height: 1.4;
    font-size: 17px;
    font-weight: 700;
    text-align: center;
    margin: 0;
    padding: 18px 16px 22px;
    transition: var(--transition);

    ${InfoBlockContainer}:hover & {
        color: var(--color-primary);
    }
`;

export const StudiesImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 400ms ease;

    ${InfoBlockContainer}:hover & {
        transform: scale(1.05);
    }
`;
